<script>
  import { innerWidth, innerHeight } from 'svelte/reactivity/window'
  import { isApp } from '@st-graphics/graphics-kit/environment'
  import { Menu, Navbar } from '@st-graphics/graphics-components'
  import { Cover, Crown, Default, FullScreen, Scrolly, SplitScreen, VideoHero } from './Options'

  let { head, menu } = $props()

  const headerMap = {
    default: Default,
    fullscreen: FullScreen,
    crown: Crown,
    scrolly: Scrolly,
    splitscreen: SplitScreen,
    videohero: VideoHero,
    cover: Cover,
  }

  let navbarSettings = {
    cover: { gradient: true, overlap: true, seamless: true },
    crown: { seamless: true },
    default: { seamless: true },
    fullscreen: { seamless: true },
    scrolly: { seamless: true, gradient: true },
    splitscreen: { seamless: true },
    videohero: { seamless: true },
  }

  let isMobile = $derived(innerWidth.current < 744)
  const SvelteComponent = $derived(headerMap[head.mode] || headerMap.default)
</script>

<header>
  <SvelteComponent
    {...head}
    innerWidth={innerWidth.current}
    innerHeight={innerHeight.current}
    {isApp}
    {isMobile}
  >
    {#snippet navbar()}
      {#if !isApp}
        <Navbar {...navbarSettings[head.mode]} />
      {/if}
    {/snippet}

    {#snippet menuitems()}
      {#if menu}
        <Menu {...menu} />
      {/if}
    {/snippet}
  </SvelteComponent>
</header>
